import type { ConversationDto } from "../../types/index.ts";

function dayKey(date: Date): string {
  return date.toLocaleDateString("sv-SE");
}

/** Today, yesterday, this week, older — the way people remember when they asked something. */
export function groupByDay(conversations: ConversationDto[], now = new Date()): [string, ConversationDto[]][] {
  const today = dayKey(now);
  const yesterday = dayKey(new Date(now.getTime() - 86_400_000));
  const weekAgo = now.getTime() - 7 * 86_400_000;
  const groups = new Map<string, ConversationDto[]>();

  for (const c of conversations) {
    const updated = new Date(c.updatedAt);
    const key = dayKey(updated);
    const label =
      key === today ? "Idag" : key === yesterday ? "Igår" : updated.getTime() > weekAgo ? "Senaste veckan" : "Tidigare";
    groups.set(label, [...(groups.get(label) ?? []), c]);
  }
  return [...groups.entries()];
}
